module.exports = __webpack_public_path__ + "img/numberBox.5a2a4cb5.png";